import { Controller } from "@hotwired/stimulus"

// Message form + list for conversations
// Values: url (the conversation URL to PUT to)
// Targets: textarea, submitBtn, list
export default class extends Controller {
  static values = { url: String }
  static targets = ["textarea", "submitBtn", "list"]

  submit(event) {
    event.preventDefault()

    const text = this.textareaTarget.value
    if (!text) return

    const token = document.querySelector('meta[name="csrf-token"]')?.content

    this.submitBtnTarget.classList.add("-is-loading")
    this.submitBtnTarget.setAttribute("disabled", true)

    fetch(this.urlValue, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": token
      },
      body: JSON.stringify({ messages_attributes: [{ body: text }] })
    })
      .then(response => response.json())
      .then(messages => {
        this.listTarget.innerHTML = messages.map(msg => this.renderMessage(msg)).join("")
        this.textareaTarget.value = ""
        this.submitBtnTarget.classList.remove("-is-loading")
        this.submitBtnTarget.removeAttribute("disabled")
      })
  }

  renderMessage(message) {
    const date = new Intl.DateTimeFormat("en-GB", {
      year: "numeric",
      month: "short",
      day: "2-digit"
    }).format(Date.parse(message.created_at))

    return `<article class="message-container">
      <label class="message-sender">
        <a href="/${this.escapeHtml(message.sender)}">${this.escapeHtml(message.sender)}</a>
      </label>
      &nbsp;&nbsp;
      <small class="message-meta">
        <time datetime="${message.created_at}">${date}</time>
      </small>
      <p class="message-text">${this.escapeHtml(message.body)}</p>
    </article>`
  }

  escapeHtml(str) {
    if (!str) return ""
    const div = document.createElement("div")
    div.textContent = str
    return div.innerHTML
  }
}
